import { Footer, Navbar, TvShowsDetails } from "../components";

const AnimeDetailsPage = () => {
  return (
    <div>
      <Navbar />
      <TvShowsDetails />
      <Footer />
    </div>
  );
};

export default AnimeDetailsPage;
